import React from 'react';
import Field from 'commonComponents/forms/Field/Field';


const MessageField = ({ name = 'notes', ...fieldProps }) => {
  return <Field name={ name } { ...fieldProps } />;
};

export { MessageField };
